import EquipmentProfileandByState from './components/drilldowns/equipmentprofilebystate';
import EquipmentProfileandByDistrict from './components/drilldowns/equipmentprofilebydistrict';
import EquipmentProfileandByGroup from './components/drilldowns/equipmentprofilebygroup';
import EquipmentProfileandByHospital from './components/drilldowns/equipmentprofilebyhospitals';
import EquipmentProfileandByHospitalDetails from './components/drilldowns/equipmentprofilebyhospitaldetails';

import CriticalEquipmentByItem from './components/drilldowns/criticalequipmentbyitem';
import CriticalEquipmentByItemDetails from './components/drilldowns/criticalequipmentbyitemdetails';

import HistoricalDysfunctionByState from './components/drilldowns/historicaldysfunctionbystate';
import HistoricalDysfunctionByDistrict from './components/drilldowns/historicaldysfunctionbydistrict';
import HistoricalDysfunctionByGroup from './components/drilldowns/historicaldysfunctionbygroup';
import HistoricalDysfunctionByHospital from './components/drilldowns/historicaldysfunctionbyhospital';
import HistoricalDysfunctionByHospitalDetails from './components/drilldowns/historicaldysfunctionbyhospitaldetails';

import BreakdownCallReportingByState from './components/drilldowns/breakdowncallreportingbystate';
import BreakdownCallReportingByDistrict from './components/drilldowns/breakdowncallreportingbydistrict';
import BreakdownCallReportingByGroup from './components/drilldowns/breakdowncallreportingbygroup';
import BreakdownCallReportingByHospital from './components/drilldowns/breakdowncallreportingbyhospital';
import BreakdownCallReportingByHospitalDetails from './components/drilldowns/breakdowncallreportingbyhospitaldetails';

import BreakdownCallCriticalOrNonCriticalByCategory from './components/drilldowns/breakdowncallcriticalornoncriticalbycategory';

import WorkInprogressByState from './components/drilldowns/workinprogressbystate';
import WorkInprogressByDistrict from './components/drilldowns/workinprogressbydistrict';
import WorkInprogressByGroup from './components/drilldowns/workinprogressbygroup';
import WorkInprogressByHospital from './components/drilldowns/workinprogressbyhospital';
import WorkInprogressByHospitalDetails from './components/drilldowns/workinprogressbyhospitaldetails';

import RepeatedBreakdownCallByState from './components/drilldowns/repeatedbreakdowncallbystate';
import RepeatedBreakdownCallByDistrict from './components/drilldowns/repeatedbreakdowncallbydistrict';
import RepeatedBreakdownCallByGroup from './components/drilldowns/repeatedbreakdowncallbygroup';
import RepeatedBreakdownCallByHospital from './components/drilldowns/repeatedbreakdowncallbyhospital';

import EquipmentCondemnationByState from './components/drilldowns/equipmentcondemnationbystate';
import EquipmentCondemnationByDistrict from './components/drilldowns/equipmentcondemnationbydistrict';
import EquipmentCondemnationByGroup from './components/drilldowns/equipmentcondemnationbygroup';
import EquipmentCondemnationByHospital from './components/drilldowns/equipmentcondemnationbyhospital';
import EquipmentCondemnationByHospitalDetails from './components/drilldowns/equipmentcondemnationbyhospitaldetails';

import PMAndCalibrationByState from './components/drilldowns/pmandcalibrationbystate';
import PMAndCalibrationByDistrict from './components/drilldowns/pmandcalibrationbydistrict';
import PMAndCalibrationByGroup from './components/drilldowns/pmandcalibrationbygroup';
import PMAndCalibrationByHospital from './components/drilldowns/pmandcalibrationbyhospital';
import PMAndCalibrationByHospitalDetails from './components/drilldowns/pmandcalibrationbyhospitaldetails';

import CalibrationByState from './components/drilldowns/calibrationbystate';
import CalibrationByDistrict from './components/drilldowns/calibrationbydistrict';
import CalibrationByGroup from './components/drilldowns/calibrationbygroup';
import CalibrationByHospital from './components/drilldowns/calibrationbyhospital';
import CalibrationByHospitalDetails from './components/drilldowns/calibrationbyhospitaldetails';

import HealthFacilityByState from './components/drilldowns/healthfacilitybystate';
import HealthFacilityByDistrict from './components/drilldowns/healthfacilitybydistrict';
import HealthFacilityByGroup from './components/drilldowns/healthfacilitybygroup';
import HealthFacilityByHospital from './components/drilldowns/healthfacilitybyhospital';

import TechnicalManPower from './components/drilldowns/technicalmanpower';
import Circulars from './components/drilldowns/circulars';

import UptimeByState from './components/drilldowns/uptimebystate';
import UptimeByDistrict from './components/drilldowns/uptimebydistrict';
import UptimeByGroup from './components/drilldowns/uptimebygroup';
import UptimeByHospital from './components/drilldowns/uptimebyhospital';

import AdditionalReports from './components/additionalreports';
import CustomerSupport from './components/customersupport';
import StandardOperatingProcedure from './components/standardoperatingprocedure';

import UserTrainingByState from './components/drilldowns/usertrainingbystate';
import UserTrainingByDistrict from './components/drilldowns/usertrainingbydistrict';
import UserTrainingByGroup from './components/drilldowns/usertrainingbygroup';
import UserTrainingByHospital from './components/drilldowns/usertrainingbyhospital';
import UserTrainingByHospitalDetails from './components/drilldowns/usertrainingbyhospitaldetails';


//For Sysmex - Breakdown Call Report
import BreakdownCallReportingByStateForSysmex from './components/drilldowns/breakdowncallreportingbystateforsysmex';
import BreakdownCallReportingByDistrictForSysmex from './components/drilldowns/breakdowncallreportingbydistrictforsysmex';
import BreakdownCallReportingByGroupForSysmex from './components/drilldowns/breakdowncallreportingbygroupforsysmex';
import BreakdownCallReportingByHospitalForSysmex from './components/drilldowns/breakdowncallreportingbyhospitalforsysmex';
import BreakdownCallReportingByHospitalDetailsForSysmex from './components/drilldowns/breakdowncallreportingbyhospitaldetailsforsysmex';

//For Sysmex - Installation Work
import InstallationWorkByState from './components/drilldowns/installationworkbystate';
import InstallationWorkByDistrict from './components/drilldowns/installationworkbydistrict';
import InstallationWorkByGroup from './components/drilldowns/installationworkbygroup';
import InstallationWorkByHospital from './components/drilldowns/installationworkbyhospital';
import InstallationWorkByHospitalDetails from './components/drilldowns/installationworkbyhospitaldetails';

export default {
	'/equipmentprofilebystate' : {
		title: 'Equipment Profile and Status By State',
		component: EquipmentProfileandByState
	},
	'/equipmentprofilebydistrict/:parentterritoryid?' : {
		title: 'Equipment Profile and Status By District',
		component: EquipmentProfileandByDistrict
	},
	'/equipmentprofilebygroup/:territoryid?' : {
		title: 'Equipment Profile and Status By Group',
		component: EquipmentProfileandByGroup
	},
	'/equipmentprofilebyhospital/:groupid/:territoryid?' : {
		title: 'Equipment Profile and Status By Hospitals',
		component: EquipmentProfileandByHospital
	},
	'/equipmentprofilebyhospitaldetails/:id' : {
		title: 'Equipment Profile and Status By Hospital Details',
		component: EquipmentProfileandByHospitalDetails
	},
	'/criticalequipmentbyitem' : {
		title: 'Critical Equipment By Item',
		component: CriticalEquipmentByItem
	},
	'/criticalequipmentbyitemdetails/:id' : {
		title: 'Critical Equipment By Item Details',
		component: CriticalEquipmentByItemDetails
	},
	'/historicaldysfunctionbystate' : {
		title: 'Historical Dysnction By State',
		component: HistoricalDysfunctionByState
	},
	'/historicaldysfunctionbydistrict/:parentterritoryid?' : {
		title: 'Historical Dysnction By District',
		component: HistoricalDysfunctionByDistrict
	},
	'/historicaldysfunctionbygroup/:territoryid?' : {
		title: 'Historical Dysnction By Group',
		component: HistoricalDysfunctionByGroup
	},
	'/historicaldysfunctionbyhospital/:groupid/:territoryid?' : {
		title: 'Historical Dysnction By Hospital',
		component: HistoricalDysfunctionByHospital
	},
	'/historicaldysfunctionbyhospital/:id' : {
		title: 'Historical Dysnction By Hospital',
		component: HistoricalDysfunctionByHospital
	},
	'/historicaldysfunctionbyhospitaldetails/:id' : {
		title: 'Historical Dysnction By Hospital Details',
		component: HistoricalDysfunctionByHospitalDetails
	},
	'/breakdowncallreportingbystate' : {
		title: 'Breakdown Call Reporting By State',
		component: BreakdownCallReportingByState
	},
	'/breakdowncallreportingbydistrict/:parentterritoryid?' : {
		title: 'Breakdown Call Reporting By District',
		component: BreakdownCallReportingByDistrict
	},
	'/breakdowncallreportingbygroup/:territoryid?' : {
		title: 'Breakdown Call Reporting By Group',
		component: BreakdownCallReportingByGroup
	},
	'/breakdowncallreportingbyhospital/:groupid/:territoryid?' : {
		title: 'Breakdown Call Reporting By Hospital',
		component: BreakdownCallReportingByHospital
	},
	'/breakdowncallreportingbyhospitaldetails/:id' : {
		title: 'Breakdown Call Reporting By Hospital Details',
		component: BreakdownCallReportingByHospitalDetails
	},
	'/breakdowncallcriticalornoncriticalbycategory' : {
		title: 'Breakdown Call Critical Or Non-Critical By Category',
		component: BreakdownCallCriticalOrNonCriticalByCategory
	},
	'/workinprogressbystate' : {
		title: 'Work In Progress By State',
		component: WorkInprogressByState
	},
	'/workinprogressbydistrict/:parentterritoryid?' : {
		title: 'Work In Progress By District',
		component: WorkInprogressByDistrict
	},
	'/workinprogressbygroup/:territoryid?' : {
		title: 'Work In Progress By Group',
		component: WorkInprogressByGroup
	},
	'/workinprogressbyhospital/:groupid/:territoryid?' : {
		title: 'Work In Progress By Hospital',
		component: WorkInprogressByHospital
	},
	'/workinprogressbyhospitaldetails/:id' : {
		title: 'Work In Progress By Hospital Details',
		component: WorkInprogressByHospitalDetails
	},
	'/repeatedbreakdowncallbystate' : {
		title: 'Repeated Breakdown Call By State',
		component: RepeatedBreakdownCallByState
	},
	'/repeatedbreakdowncallbydistrict/:parentterritoryid?' : {
		title: 'Repeated Breakdown Call By District',
		component: RepeatedBreakdownCallByDistrict
	},
	'/repeatedbreakdowncallbygroup/:territoryid?' : {
		title: 'Repeated Breakdown Call By Group',
		component: RepeatedBreakdownCallByGroup
	},
	'/repeatedbreakdowncallbyhospital/:groupid/:territoryid?' : {
		title: 'Repeated Breakdown Call By Hospital',
		component: RepeatedBreakdownCallByHospital
	},
	'/equipmentcondemnationbystate' : {
		title: 'Equipment Condemnation By State',
		component: EquipmentCondemnationByState
	},
	'/equipmentcondemnationbydistrict/:parentterritoryid?' : {
		title: 'Equipment Condemnation By District',
		component: EquipmentCondemnationByDistrict
	},
	'/equipmentcondemnationbygroup/:territoryid?' : {
		title: 'Equipment Condemnation By Group',
		component: EquipmentCondemnationByGroup
	},
	'/equipmentcondemnationbyhospital/:groupid/:territoryid?' : {
		title: 'Equipment Condemnation By Hospital',
		component: EquipmentCondemnationByHospital
	},
	'/equipmentcondemnationbyhospitaldetails/:id' : {
		title: 'Equipment Condemnation By Hospital Details',
		component: EquipmentCondemnationByHospitalDetails
	},
	'/pmandcalibrationbystate' : {
		title: 'Preventive Maintenance By State',
		component: PMAndCalibrationByState
	},
	'/pmandcalibrationbydistrict/:parentterritoryid?' : {
		title: 'Preventive Maintenance By District',
		component: PMAndCalibrationByDistrict
	},
	'/pmandcalibrationbygroup/:territoryid?' : {
		title: 'Preventive Maintenance By Group',
		component: PMAndCalibrationByGroup
	},
	'/pmandcalibrationbyhospital/:groupid/:territoryid?' : {
		title: 'Preventive Maintenance By Hospital',
		component: PMAndCalibrationByHospital
	},
	'/pmandcalibrationbyhospitaldetails/:id' : {
		title: 'Preventive Maintenance By Hospital Details',
		component: PMAndCalibrationByHospitalDetails
	},
	'/calibrationbystate' : {
		title: 'Calibration By State',
		component: CalibrationByState
	},
	'/calibrationbydistrict/:parentterritoryid?' : {
		title: 'Calibration By District',
		component: CalibrationByDistrict
	},
	'/calibrationbygroup/:territoryid?' : {
		title: 'Calibration By Group',
		component: CalibrationByGroup
	},
	'/calibrationbyhospital/:groupid/:territoryid?' : {
		title: 'Calibration By Hospital',
		component: CalibrationByHospital
	},
	'/calibrationbyhospitaldetails/:id' : {
		title: 'Calibration By Hospital Details',
		component: CalibrationByHospitalDetails
	},
	'/healthfacilitybystate' : {
		title: 'Health Facility',
		component: HealthFacilityByState
	},
	'/healthfacilitybydistrict/:parentterritoryid?' : {
		title: 'Health Facility',
		component: HealthFacilityByDistrict
	},
	'/healthfacilitybygroup/:territoryid?' : {
		title: 'Health Facility',
		component: HealthFacilityByGroup
	},
	'/healthfacilitybyhospital/:groupid/:territoryid?' : {
		title: 'Health Facility',
		component: HealthFacilityByHospital
	},
	'/uptimebystate' : {
		title: 'Uptime By State',
		component: UptimeByState
	},
	'/uptimebydistrict/:parentterritoryid?' : {
		title: 'Uptime By District',
		component: UptimeByDistrict
	},
	'/uptimebygroup/:territoryid?' : {
		title: 'Uptime By Group',
		component: UptimeByGroup
	},
	'/uptimebyhospital/:groupid/:territoryid?' : {
		title: 'Uptime By Hospital',
		component: UptimeByHospital
	},
	'/technicalmanpower' : {
		title: 'Technical Manpower',
		component: TechnicalManPower
	},
	'/circulars' : {
		title: 'Circulars',
		component: 	Circulars

	},
	'/additionalreports' : {
		title: 'Additional Reports',
		component: AdditionalReports
	},
	'/customersupport' : {
		title: 'Customer Support',
		component: CustomerSupport
	},
	'/standardoperatingprocedure' : {
		title: 'Standard Operating Procedure',
		component: StandardOperatingProcedure
	},
	'/usertrainingbystate' : {
		title: 'User Training By State',
		component: UserTrainingByState
	},
	'/usertrainingbydistrict/:parentterritoryid?' : {
		title: 'User Training By District',
		component: UserTrainingByDistrict
	},
	'/usertrainingbygroup/:territoryid?' : {
		title: 'User Training By Group',
		component: UserTrainingByGroup
	},
	'/usertrainingbyhospital/:groupid/:territoryid?' : {
		title: 'User Training By Hospital',
		component: UserTrainingByHospital
	},
	'/usertrainingbyhospitaldetails/:id' : {
		title: 'User Training By Hospital Details ',
		component: UserTrainingByHospitalDetails
	},

	// For Sysmex - Breakdown Call Reports
	'/breakdowncallreportingbystateforsysmex' : {
		title: 'Breakdown Call Reporting By State',
		component: BreakdownCallReportingByStateForSysmex
	},
	'/breakdowncallreportingbydistrictforsysmex/:parentterritoryid?' : {
		title: 'Breakdown Call Reporting By District',
		component: BreakdownCallReportingByDistrictForSysmex
	},
	'/breakdowncallreportingbygroupforsysmex/:territoryid?' : {
		title: 'Breakdown Call Reporting By Group',
		component: BreakdownCallReportingByGroupForSysmex
	},
	'/breakdowncallreportingbyhospitalforsysmex/:groupid/:territoryid?' : {
		title: 'Breakdown Call Reporting By Hospital',
		component: BreakdownCallReportingByHospitalForSysmex
	},
	'/breakdowncallreportingbyhospitaldetailsforsysmex/:id' : {
		title: 'Breakdown Call Reporting By Hospital Details',
		component: BreakdownCallReportingByHospitalDetailsForSysmex
	},

	//For Sysmex - Installation Work

	'/installationworkbystate' : {
		title: 'Installation Work By State',
		component: InstallationWorkByState
	},
	'/installationworkbydistrict/:parentterritoryid?' : {
		title: 'Installation Work By District',
		component: InstallationWorkByDistrict
	},
	'/installationworkbygroup/:territoryid?' : {
		title: 'Installation Work By Group',
		component: InstallationWorkByGroup
	},
	'/installationworkbyhospital/:groupid/:territoryid?' : {
		title: 'Installation Work By Hospital',
		component: InstallationWorkByHospital
	},
	'/installationworkbyhospital/:id' : {
		title: 'Installation Work By Hospital',
		component: InstallationWorkByHospital
	},
	'/installationworkbyhospitaldetails/:id' : {
		title: 'Installation Work By Hospital Details',
		component: InstallationWorkByHospitalDetails
	},
}



// WEBPACK FOOTER //
// ./public/react/routeconfig.js